import { render, staticRenderFns } from "./CierresComponent.vue?vue&type=template&id=d0de3b5e&"
import script from "./CierresComponent.vue?vue&type=script&lang=js&"
export * from "./CierresComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports